import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormControlLabel, Checkbox, Typography } from '@material-ui/core';
import { useTranslation } from 'utils/modifiedTranslation';
import useStyles from './styles';

export const CheckboxNew = (props) => {
  const {
    label,
    onChange,
    checked,
    checkboxClassName,
    labelClassName,
    topographyClassName,
    isRequired = false,
    labelHTML,
    isDefault,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <FormControlLabel
      className={cx(classes.label, labelClassName)}
      control={(
        <Checkbox
          className={cx(classes.checkbox, checkboxClassName)}
          onChange={onChange}
          checked={checked}
          required={isRequired}
          color={isDefault ? 'default' : 'primary'}
          size="small"
        />
      )}
      label={(
        <Typography className={topographyClassName}>
          {labelHTML ? (
            <span dangerouslySetInnerHTML={{ __html: labelHTML }} />
          ) : t(label)}
          {isRequired && (
            <span className={classes.labelText}>
              {'  '}
              *
            </span>
          )}
        </Typography>
      )}
    />
  );
};

CheckboxNew.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  checkboxClassName: PropTypes.string,
  topographyClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  labelHTML: PropTypes.string,
  isRequired: PropTypes.bool,
  isDefault: PropTypes.bool,
};

CheckboxNew.defaultProps = {
  checkboxClassName: '',
  labelClassName: '',
  isRequired: false,
  isDefault: false,
  labelHTML: '',
};
